import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import Axios from 'axios'
import { fetchApi } from "../../tools"
import { Field, ErrorMessage, useFormik } from 'formik'
import { ExclamationCircleIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import ToggleFacturacion from "./ToggleFacturacion"
import { CheckCircleIcon} from "@heroicons/react/24/outline"
import WarningModal from "../../components-modals/WarningModal"

function classNames(...classes){
    return classes.filter(Boolean).join(" ")
}

export default function FacturacionForm({ url, setProducto, url2, col=false, setMensaje, mensaje, headers, centro=0, setCentro, enviarModificado, setBotonesDescripcion=false, botonesDescripcion, productoSeleccionado, modal, setModal, values, setFieldValue, resetForm, setRawData, setShowSearchModal, setEnableVoucher, primerIdBodega, hayEdicion, setHayEdicion, showIcon=true }) {

    const bodegas = useSelector(state => state.auth.bodegas)
    
    //handle de onBlur para manejar la consulta a API de la SAT para NIT valido
    const handleNit = async (e, setFieldValue, resetForm, values) => {
        setMensaje(()=>{return true})
        if(e.target.value.toUpperCase() === "CF"){
            setFieldValue('NombreDoc', 'CONSUMIDOR FINAL')
            setModal({
                ok: false,
                show: true,
                msg: "La factura será emitida como consumidor final"
            })
        }else{
            if (!e.target.value) {
                return;
            }
    
            try {
                const res = await Axios({
                    method: 'GET',
                    url: url + '/utils/cliente',
                    headers,
                    params: {
                        "Nit": e.target.value
                    }
                })
    
                const { Nombre = '', Direccion = 'Ciudad', Error } = res.data.msg
    
                if (Error !== "1001" || e.target.value.toUpperCase() === 'CF') {
                    setFieldValue('Nit', e.target.value.toUpperCase())
                    setFieldValue('NombreDoc', e.target.value.toUpperCase() === 'CF' ? values.NombreDoc : Nombre)
                    setFieldValue('Direccion', Direccion)
                } else {
                    throw new Error();
                }
    
            } catch (err) {
                console.log(err)
                setFieldValue('Nit', '')
                setFieldValue('NombreDoc', '')
                setFieldValue('Direccion', '')
                setModal({
                    msg: 'NIT no existe!',
                    ok: false,
                    show: true
                })
            }
        }
    }// Fin de handler de OnBlur

    const fetchDataNit = async (Nit, NombreDoc) => {
        setMensaje(()=>{return true})
        try {
            const res = await Axios({
                method: 'GET',
                url: url + '/utils/cliente',
                headers,
                params: {
                    "Nit": Nit
                }
            })

            const { Nombre = '', Direccion = 'Ciudad', Error } = res.data.msg

            if (Error !== "1001") {
                setFieldValue('Nit', Nit)
                setFieldValue('NombreDoc', Nombre)
                setFieldValue('Direccion', Direccion)
            } else {
                setFieldValue('Nit', 'CF')
                setFieldValue('NombreDoc', NombreDoc)                
            }

        } catch (err) {
            setModal({
                show: true,
                ok: false,
                msg: 'Sin resultados, intente de nuevo.'
            })
            console.log(err)
        }
    }

    //handle de onBlur para manejar la consulta a API de la SAT para Carnet valido
    const handleCarnet = async (e, setFieldValue, resetForm, values) => {
        setMensaje(()=>{return true})
        if (!e.target.value) {
            return;
        }

        try {

            const res = await Axios({
                method: 'GET',
                url: url + '/utils/busquedas',
                headers,
                params: {
                    "opcion": "ALUMNOS",
                    "Carnet": e.target.value
                }
            })

            const { Alumno = '', NombreDoc = '', Nit = 'CF', Celular = '', Email = '' } = res.data.msg[0]

            const resNit = (Nit.toUpperCase() === 'C/F' || Nit === '' ? 'CF' : Nit)

            setFieldValue('Alumno', Alumno)
            setFieldValue('Cel', Celular)
            setFieldValue('Email', Email)

            fetchDataNit(resNit, NombreDoc)

        } catch (err) {
            setFieldValue('Carnet', '')
            setFieldValue('Alumno', '')
            setFieldValue('Cel', '')
            setFieldValue('Email', '')
            setFieldValue('Nit', 'CF')
            setFieldValue('NombreDoc', '')
            setFieldValue('Direccion', '')
            //setFieldValue
            setModal({
                show: true,
                ok: false,
                msg: 'Carnet no existe!'
            })
            console.log(err)
        }
    }// Fin de handler de OnBlur

    //onCHange handler de bodega
    const handleBodega = async (e, setFieldValue) => {
        if(centro === 0){
            setMensaje(()=>{return true})
            setFieldValue('IdBodega', e.target.value);
            if (!e.target.value) {
                setRawData([]);
                return;
            }
            
            //setLoading(true);
            try {
                const res = await Axios({
                method: 'GET',
                url: url + '/utils/busquedas',
                headers,
                params: {
                    "opcion": "PRODUCTOS",
                    "IdBodega": e.target.value,
                }
            })
            setRawData(res.data.msg)
            if (res.data.length > 0) setEnableVoucher(res.data.msg[0].Voucher)
        } catch (err) {
            console.log(err)
        }
    }
    }

    //Restringir el campo de Cel a que el usuario solo pueda ingresar números sin espacios.
    const formatTel = (e) => {

        const isNumber = (x) => {
            const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            return numbers.some(y => y === Number(x))
        }

        if (isNumber(e.target.value.slice(-1))) {

            if (e.target.value.length > 8) {
                return setFieldValue('Cel', e.target.value.trim().slice(0, -1))
            }

            setFieldValue('Cel', e.target.value.replace(/ /g, ''));
        }
    }

    const formatCarnet = (e) => {
        if (e.target.value.length > 12) {
            return setFieldValue('Carnet', e.target.value.trim().slice(0, -1))
        }

        setFieldValue('Carnet', e.target.value.replace(/ /g, ''));
    }

    useEffect(() => {
      fetchData(values.Centro)
    }, [])

    
    
    const fetchData = async (centro) => {
        if(centro === 0){
            setMensaje(()=>{return false})
            //setLoading(true);
            try {
                const res = await fetchApi({
                    url:url2,
                    headers:headers,
                    content: {
                        opcion: "PRODUCTOS",
                        IdBodega: centro? undefined: primerIdBodega ,
                        "Centro" : centro
                    },
                });
                setRawData(res);
                // if (res.data.msg?.length > 0) setEnableVoucher(res.data.msg[0].Voucher);
                if (res.msg?.length > 0) setEnableVoucher(res.msg[0].Voucher);
            } catch (err) {
                console.log(err);
            }
        }
    };


    const [modificado, setModificado] = useState("")
    const [precioModificado, setPrecioModificado] = useState(0)
    
    const handleModificado = (valor) => {
        setHayEdicion(true)
        setModificado(valor)
    }

    const handlePrecioModificado = (valor) => {
        setHayEdicion(true)
        setPrecioModificado(valor)
    }
      
    function run(valor){
        if(!(valor).toString().split("").includes(".")){
            return `${valor}.00`
        }else{
            return valor
        }
    }

    return (
        <div className="px-4 py-5 sm:p-6">
        <WarningModal
        open={modal.show? true: false}
        width={botonesDescripcion ? "w-[40%]" : undefined}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className={showIcon?"h-20 w-20 text-red-500 mx-auto":"hidden"}/>
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        {((botonesDescripcion && centro) && !mensaje)?
        <div className="flex flex-col mt-2">
            <div className="flex flex-col w-4/4">
              <label htmlFor="description" className="text-white">Nueva descripción</label>
              <textarea name="description" autoFocus className="rounded-md mb-2" onChange={(e) => handleModificado(e.target.value)} defaultValue={productoSeleccionado.Descripcion}></textarea>
            </div>
            <div className="flex flex-col w-[20%]">
              <label htmlFor="valor" className="text-white">Nuevo valor</label>
              <input type="number" name="valor" className="rounded-md p-2" onChange={(e) => handlePrecioModificado(e.target.value)} defaultValue={run(productoSeleccionado.Precio)}></input>
            </div>
        </div>
        : null
        }

        {!mensaje?
        <div className="mt-5 sm:mt-6 flex flex-row gap-2 justify-center">
            
        <button
            onClick={
              botonesDescripcion ?
              () => {
                  setHayEdicion(false)
                  setMensaje(false)
                  enviarModificado(undefined)
                  setBotonesDescripcion(false)
                  setModal((curr) => ({
                      ...curr,
                      show: false,
                    }))
              }
              :
              () => {
                  setHayEdicion(false)
                  setMensaje(false)
                  setModal((curr) => ({
                      ...curr,
                      show: false,
                    }));
              }
            }
            type="button"
            className="inline px-12 justify-center rounded-md border border-azulBrillanteMira bg-transparent /px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-azulBrillanteMira transition duration-500 ease focus:outline-none sm:text-sm"
          >
            {"No"}
          </button>

          <button
            onClick={
                botonesDescripcion ?
                () => {
                        setMensaje(false)
                        enviarModificado(modificado, precioModificado)
                        setBotonesDescripcion(false)
                        setModal((curr) => ({
                            ...curr,
                            show: false,
                        }))
                    
                }
                :
                ()=>{
                    setMensaje(false)
                    setModal((curr) => ({
                        ...curr,
                        show: false,
                    }));
                }
            }
            type="button"
            className="inline  justify-center rounded-md border border-transparent bg-azulBrillanteMira px-12 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            {"Sí"}
          </button>
        </div>: null}
        {mensaje && 
        <div className="mt-5 sm:mt-6">
                
        <button
          onClick={() => {
            if (modal.reload) {
              window.location.reload();
            }
            setModal((curr) => ({
              ...curr,
              show: false,
              reload: false,
            }));
          }}
          type="button"
          className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
          Entendido
        </button>
        </div>}
      </WarningModal>
            <div className={col? "lg:grid lg:grid-cols-2 lg:gap-5 /ml-3": "lg:grid lg:grid-cols-2 lg:gap-5 ml-3"}>
                <div className={classNames(centro?"":"mb-4", "lg:col-span-2  flex flex-col w-full")}>
                    <div className="/mb-4">
                    
                  </div>
                    <h3 className="text-lg font-medium leading-6 text-white">1. Rellenar los campos</h3>
                    <p className="mt-1 text-sm text-grisMira">Rellene la información respectiva a la factura.</p>
                </div>

                <div className="mt-5 lg:col-span-2 lg:mt-0">
                    <div className="grid grid-cols-6 gap-3">
                        
                    {!col?<div className="col-span-6 mb-4">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                    Bodega
                                </label>
                                <ErrorMessage component="p" name="IdBodega" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                onChange={async (e) => await handleBodega(e, setFieldValue)}
                                name='IdBodega'
                                as='select'
                                className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                {bodegas.map((bodega, key) => bodega.IdBodega !== 0 ? <option key={key} value={bodega.IdBodega}>{bodega.NombreBodega}</option> : null)}
                            </Field>
                        </div>: null}

                        {!col?<div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                    Carnet
                                </label>
                                <ErrorMessage component="p" name="Carnet" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                onBlur={async (e) => await handleCarnet(e, setFieldValue, resetForm, values)}
                                onChange={formatCarnet}
                                name="Carnet"
                                type='text'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>:null}

                        {!col?<div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                    Alumno
                                </label>
                                <ErrorMessage component="p" name="Alumno" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <div className="flex">
                                <Field
                                    name="Alumno"
                                    type="text"
                                    className="mt-1 block w-full rounded-l-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                                <button
                                    onClick={() => setShowSearchModal(true)}
                                    type="button"
                                    className="mt-1 rounded-r-md border border-azulLogos bg-azulLogos px-4 py-2 text-sm font-medium text-white hover:bg-primarioMira hover:border-azulLogos"
                                >
                                    <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>:null}
                        
                        {/*<ToggleFacturacion
                          label="ddd"
                          setFieldValue={setFieldValue}
                          values={values}
                        />
                        <ToggleFacturacion
                          label="ddd"
                          setFieldValue={setFieldValue}
                          values={values}
                         />*/}

                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                    Nit
                                </label>
                                <ErrorMessage component="p" name="Nit" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                onBlur={async (e) => await handleNit(e, setFieldValue, resetForm, values)}
                                name='Nit'
                                type='text'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>

                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                    {"Nombre*"}
                                </label>
                                <ErrorMessage component="p" name="NombreDoc" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                name='NombreDoc'
                                type='text'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>

                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                {!col?"Celular*":"Celular"}
                                </label>
                                <ErrorMessage component="p" name="Cel" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                onChange={formatTel}
                                value={values.Cel}
                                name='Cel'
                                type='text'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>

                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                {!col?"Email*":"Email"}
                                </label>
                                <ErrorMessage component="p" name="Email" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                name='Email'
                                type='email'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>

                        <div className="col-span-6">
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-grisMira">
                                {!col?"Dirección*":"Dirección"}
                                </label>
                                <ErrorMessage component="p" name="Direccion" className="w-full text-right block text-sm font-semibold text-red-500" />
                            </div>
                            <Field
                                name='Direccion'
                                type='text'
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}